import React, { useState } from 'react';
import { Lock, Mail, Loader2 } from 'lucide-react';
import { useAuth } from './AuthContext';
import { useNavigate, Navigate } from 'react-router-dom';
import Logo from '../components/Logo';

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  if (admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setBusy(true);
    try {
      await login(email.trim(), password);
      navigate('/admin');
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Invalid credentials');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#072A1F] px-6">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-10"><Logo size="lg" /></div>

        <form onSubmit={submit} className="bg-[#124D3A] border border-[#D4AF37]/15 rounded-3xl p-8 shadow-2xl" data-testid="admin-login-form">
          <h1 className="font-serif-display text-3xl text-[#ffffff] mb-1">Admin Login</h1>
          <p className="text-sm text-[#ffffff]/60 mb-7">Sign in to manage your clinic.</p>

          <label className="block mb-4">
            <span className="block text-[11px] tracking-[0.18em] uppercase text-[#D4AF37] mb-2">Email</span>
            <div className="relative">
              <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-[#D4AF37]" />
              <input
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@goldcare.clinic"
                data-testid="admin-login-email"
                className="w-full pl-11 pr-4 py-3 rounded-full bg-[#072A1F] border border-[#D4AF37]/25 text-[#ffffff] placeholder:text-[#ffffff]/40 outline-none focus:border-[#D4AF37]"
              />
            </div>
          </label>

          <label className="block mb-6">
            <span className="block text-[11px] tracking-[0.18em] uppercase text-[#D4AF37] mb-2">Password</span>
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-[#D4AF37]" />
              <input
                type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                data-testid="admin-login-password"
                className="w-full pl-11 pr-4 py-3 rounded-full bg-[#072A1F] border border-[#D4AF37]/25 text-[#ffffff] placeholder:text-[#ffffff]/40 outline-none focus:border-[#D4AF37]"
              />
            </div>
          </label>

          {error && <div data-testid="admin-login-error" className="text-sm text-red-300 bg-red-900/20 border border-red-400/30 px-4 py-2.5 rounded-xl mb-5">{error}</div>}

          <button
            type="submit" disabled={busy}
            data-testid="admin-login-submit"
            className="btn-gold w-full py-3.5 rounded-full text-sm font-semibold flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {busy && <Loader2 className="w-4 h-4 animate-spin" />}
            {busy ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <p className="text-center text-xs text-[#ffffff]/45 mt-6">Restricted area · Gold Care Esthetic</p>
      </div>
    </div>
  );
}
